import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Phone } from 'src/app/core/models/phone.model';


@Component({
  selector: 'app-proprietary-modal',
  templateUrl: './proprietary-modal.component.html',
  styleUrls: ['./proprietary-modal.component.scss']
})
export class ProprietaryModalComponent implements OnInit {

  @Output() public closeModal = new EventEmitter<boolean>();
  @Output() public sendItems = new EventEmitter<boolean>();
  @Input() public titleModal = '';

  public form: FormGroup;
  private docBody = document.querySelector('body');

  public phonesAlternative: Phone[] = [];
  public listPhones: Phone[] = [];

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.docBody.setAttribute('style', 'overflow: hidden');
    this.initializeForm();
  }

  private initializeForm() {
    this.form = this.fb.group({
      name: [null],
      email: [null],
      cpf: [null],
      rg: [null],
      phone_main: [{ddi: '', phone: ''}],
      phone_alternative: [[]]
    });
  }

  public cancel() {
    this.docBody.setAttribute('style', 'overflow: auto');
    this.closeModal.emit(false);
  }

  public sendItem() {
    this.docBody.setAttribute('style', 'overflow: auto');
    this.sendItems.emit(this.form.value);
    this.closeModal.emit(false);
  }

  public addPhoneAlternative() {
    this.phonesAlternative.push({
      phone: '',
      ddi: ''
    });
    this.form.get('phone_alternative').setValue(this.listPhones);
  }

  public changesPhoneMain(event: Phone) {
    this.form.get('phone_main').setValue(event);
  }

  public changesPhone(event: Phone, i: number) {
    this.listPhones[i] = event;
  }

}
